<template>
  <div class="call-controls">
    <v-btn
      v-if="!callActive"
      color="#6f8063"
      dark
      depressed
      class="call-controls__primary"
      :loading="loading"
      :disabled="disabled"
      @click="$emit('activate')"
    >
      <v-icon left>mdi-video-outline</v-icon>
      Ativar voz e video
    </v-btn>

    <template v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="call-controls__icon"
            :class="{ 'call-controls__icon--off': !audioEnabled }"
            v-bind="attrs"
            v-on="on"
            @click="$emit('toggle-audio')"
          >
            <v-icon>{{ audioEnabled ? 'mdi-microphone' : 'mdi-microphone-off' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ audioEnabled ? 'Mutar microfone' : 'Ativar microfone' }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="videoAvailable"
            icon
            class="call-controls__icon"
            :class="{ 'call-controls__icon--off': !videoEnabled }"
            v-bind="attrs"
            v-on="on"
            @click="$emit('toggle-video')"
          >
            <v-icon>{{ videoEnabled ? 'mdi-video' : 'mdi-video-off' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ videoEnabled ? 'Desligar camera' : 'Ligar camera' }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="call-controls__end"
            v-bind="attrs"
            v-on="on"
            @click="$emit('end')"
          >
            <v-icon>mdi-phone-hangup</v-icon>
          </v-btn>
        </template>
        <span>Encerrar chamada</span>
      </v-tooltip>
    </template>

    <span v-if="remoteWaiting && !callActive" class="call-controls__hint">
      Parceira aguardando voce entrar
    </span>
  </div>
</template>

<script>
export default {
  name: 'BibleCallControls',
  props: {
    callActive: {
      type: Boolean,
      default: false,
    },
    audioEnabled: {
      type: Boolean,
      default: true,
    },
    videoEnabled: {
      type: Boolean,
      default: true,
    },
    videoAvailable: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    remoteWaiting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.call-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px 4px 2px;
}

.call-controls__primary {
  border-radius: 8px;
  letter-spacing: 0;
  text-transform: none;
}

.call-controls__icon,
.call-controls__end {
  background: #f8f4eb;
  color: #665c51;
  border: 1px solid rgba(111, 128, 99, 0.16);
}

.call-controls__icon--off,
.call-controls__end {
  background: #f7e9e5;
  color: #9b4e42;
}

.call-controls__hint {
  color: #6e675d;
  font-size: 0.84rem;
  font-weight: 600;
}
</style>
